import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className={`w-12 h-12 flex items-center justify-center rounded-full ${
              isScrolled ? 'bg-[#E63946]' : 'bg-white'
            }`}>
              <i className={`ri-restaurant-line text-2xl ${
                isScrolled ? 'text-white' : 'text-[#E63946]'
              }`}></i>
            </div>
            <span className={`text-2xl font-bold ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}>
              Kebabish
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`font-semibold hover:text-[#E63946] transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Inicio
            </Link>
            <Link
              to="/menu"
              className={`font-semibold hover:text-[#E63946] transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Menú
            </Link>
            <Link
              to="/order"
              className={`font-semibold hover:text-[#E63946] transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Hacer Pedido
            </Link>
            <button
              onClick={() => scrollToSection('about')}
              className={`font-semibold hover:text-[#E63946] transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Nosotros
            </button>
            <button
              onClick={() => scrollToSection('location')}
              className={`font-semibold hover:text-[#E63946] transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Ubicación
            </button>
            <a
              href="tel:919123048"
              className="bg-[#E63946] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#D62839] transition-colors whitespace-nowrap cursor-pointer"
            >
              919 123 048
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white shadow-lg rounded-2xl mt-2 py-4 px-6">
            <Link
              to="/"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block py-3 text-gray-700 font-semibold hover:text-[#E63946] transition-colors cursor-pointer"
            >
              Inicio
            </Link>
            <Link
              to="/menu"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block py-3 text-gray-700 font-semibold hover:text-[#E63946] transition-colors cursor-pointer"
            >
              Menú
            </Link>
            <Link
              to="/order"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block py-3 text-gray-700 font-semibold hover:text-[#E63946] transition-colors cursor-pointer"
            >
              Hacer Pedido
            </Link>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left py-3 text-gray-700 font-semibold hover:text-[#E63946] transition-colors cursor-pointer"
            >
              Nosotros
            </button>
            <button
              onClick={() => scrollToSection('location')}
              className="block w-full text-left py-3 text-gray-700 font-semibold hover:text-[#E63946] transition-colors cursor-pointer"
            >
              Ubicación
            </button>
            <a
              href="tel:919123048"
              className="block mt-4 bg-[#E63946] text-white px-6 py-3 rounded-full font-semibold text-center hover:bg-[#D62839] transition-colors whitespace-nowrap cursor-pointer"
            >
              919 123 048
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
